import classNames from "classnames";
import { get } from "lodash";
import { useState } from "react";
import { MdClose, MdPhone } from "react-icons/md";
import { useMediaQuery } from "react-responsive";
import { useMutation } from "shared/hooks/useApi";
import { UPDATE_PROJECT } from "utils/api/graphql/mutations/projects";
import Button from "../../../Button";
import HelpModal from "./Modal";
import HelpContactModal from "./ModalContact";

function Help({ project, refetchProject }) {
  const [open, setOpen] = useState(false);
  const [bottomHelpOpen, setBottomHelpOpen] = useState(false);
  const [updateProject] = useMutation(UPDATE_PROJECT);

  const onSubmit = (data) =>
    updateProject({
      variables: {
        where: { id: project?.id },
        data,
      },
    });

  const onClose = () => setOpen(false);
  const onOpen = () => setOpen(true);

  const MODAL = {
    [true]: (
      <HelpContactModal
        open={open}
        onSubmit={onSubmit}
        onClose={onClose}
        project={project}
        refetchProject={refetchProject}
      />
    ),
    [false]: (
      <HelpModal
        open={open}
        onSubmit={onSubmit}
        onClose={onClose}
        project={project}
      />
    ),
  };

  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <>
      <div
        className={classNames("mobilityMutual__help", {
          rounded: !!get(project, "contact.user.firstname"),
        })}
        onClick={onOpen}
      >
        <MdPhone size={isMobile ? 24 : 24} />
        <span
          className={classNames({
            hidden: !!get(project, "contact.user.firstname"),
          })}
        >
          Être rappelé
        </span>
      </div>
      <div className="mobilityMutual__bottom-help">
        {bottomHelpOpen && (
          <div
            className="mobilityMutual__bottom-help--close"
            onClick={() => setBottomHelpOpen(!bottomHelpOpen)}
          >
            Fermer
            <MdClose size={20} />
          </div>
        )}
        <div
          className="mobilityMutual__bottom-help--icon"
          onClick={() => setBottomHelpOpen(!bottomHelpOpen)}
        >
          <MdPhone size={20} />
          <span>Je veux être rappelé(e) et conseillé(e)</span>
        </div>
        {bottomHelpOpen && (
          <div className="mobilityMutual__bottom-help--content">
            <span>
              Besoin d’aide pour vous décider ? Un conseiller peut vous rappeler
            </span>
            <Button
              type="primary"
              alignment="center"
              width="auto"
              onClick={onOpen}
            >
              Être rappelé(e)
            </Button>
          </div>
        )}
      </div>
      {MODAL[!!get(project, "contact.user.firstname")]}
    </>
  );
}

export default Help;
